// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9760) return "static/chunks/9760-9a004b0afa106590.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2697":"6d2b60a9","8176":"757b1f5f","9918":"4596ecfc"}[chunkId] || chunkId) + "." + {"638":"1a6a0d3defd6c327","2697":"eadd453436d59c31","3555":"1427c69925638480","3599":"cf51f91a46192863","6021":"9ed4e01957384398","7661":"1fde3e9367061344","8176":"bd74bff56a35c48e","9161":"b394642c048310ba","9918":"0b633399ddd01ba0"}[chunkId] + ".js";
};